import React from 'react';
import { LiaFileInvoiceDollarSolid } from "react-icons/lia";
import { MdOutlineWarehouse } from "react-icons/md";
import { CiBoxes } from "react-icons/ci";

export default function OrdersSummary(props: any) {
  const { summary = {} } = props;
  
  return (
    <>
      <div className="dashboard_row">
        <div id="totalSales" className="boxIndicator">
          <div className="boxIndicatorContent">
            <LiaFileInvoiceDollarSolid size={40} />
            <div className="boxIndicatorContentInner">
              <h2>TOTAL VENTAS</h2>
              <span className="indicatorValue">${Number(summary.total_sales).toLocaleString()}</span>
            </div>
          </div>
        </div>
        <div id="totalProducts" className="boxIndicator">
          <div className="boxIndicatorContent">
            <CiBoxes size={40} />
            <div className="boxIndicatorContentInner">
              <h2>PRODUCTOS</h2>
              <span className="indicatorValue">{summary.total_products}</span>
            </div>
            <div className="boxIndicatorContentInner">
              <h2>VENDIDOS</h2>
              <span className="indicatorValue">{summary.total_sell_products}</span>
            </div>
            <div className="boxIndicatorContentInner">
              <h2>%</h2>
              <span className="indicatorValue">{summary.sell_percentage}</span> 
            </div>
          </div>
        </div>
      </div>
      <div className="dashboard_row">
        <div id="totalOrders" className="boxIndicator">
          
          <div className="boxIndicatorContent">
            
            <div className="boxIndicatorContentInner">
              <h2>TOTAL PEDIDOS</h2>
              <span className="indicatorValue">{summary.total_orders}</span>
            </div>

            <div className="boxIndicatorContentInner">
              <h2>TOTAL VISITAS</h2>
              <span className="indicatorValue">{summary.total_visits}</span>
            </div>

            <div className="boxIndicatorContentInner">
              <h2>NO EFECTIVAS</h2>
              <span className="indicatorValue">{summary.total_non_effective}</span>
            </div>

            <div className="boxIndicatorContentInner">
              <h2>COTIZACIONES</h2>
              <span className="indicatorValue">{summary.total_quotations}</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
